<script lang="ts">
    import sanityImage from "../../sanity/sanityImage";
    import Container from "../containers/Container.svelte";
    import ArticleCard from "../elements/ArticleCard.svelte";

    export let title : string = "";
    export let heading : string = ""
    export let bottomWave : boolean = true
    export let topWave : boolean = true
    export let articles : any;
    export let showDescription: boolean = true

</script>
<Container padding="none">
    <div class="articles" class:no-wave-bottom={!bottomWave} class:no-wave-top={!topWave}>
        <h2 class:no-description={!showDescription}>{#if heading}{heading}{:else}Insights for hiring <span>{title}</span>{/if}</h2>
        {#if showDescription}<p>Not hiring just yet? Check out resources and insights from industry experts on our <a data-sveltekit-reload href="https://www.offerzen.com/blog">blog.</a></p>{/if}
        <div class="article__cards">
            {#each articles as article}
                <ArticleCard
                    heading={article.heading}
                    description={article.description}
                    url={article.url}
                    image={sanityImage(article.image.asset._ref)}
                />
            {/each}
        </div>
    </div>
</Container>

<style lang="postcss">
    @import '../../styles/_mixins.css';
    .articles {

        display: flex;
        align-items: center;
        flex-direction: column;
        padding:0;

        @mixin screen-lg {
            padding:0px 80px;
        }

        @mixin screen-md {
            padding:0px 60px;
            align-items:flex-start;
        }

        @mixin screen-sm {
            padding:60px 0px;
            align-items:center;
        }

        & h2 {
            @mixin heading-h2;
            text-align:center;
            color:var(--color_white);

            @mixin screen-md {
                max-width:100%;
                text-align:left;
            }

            @mixin screen-sm {
                padding:0 38px 8px;
            }

            & span {
                color:var(--color_offerzen_cerulean);
            }
        }

        & .no-description {
            margin:16px 0 80px;

            @mixin screen-md {
                margin:0 0 60px;
            }

            @mixin screen-sm {
                margin-bottom:40px;
            }
        }

        & p {
            max-width: 850px;
            text-align: center;
            margin:16px 0 80px;
            color:var(--color_offerzen_lightblue_secondary);
            @mixin paragraph;

            & a {
                color:var(--color_offerzen_cerulean);
                text-decoration:none;
            }

            @mixin screen-md {
               max-width:550px;
               margin:0 0 60px;
               text-align:left;
            }

            @mixin screen-sm {
                text-align:left;
                max-width:100%;
                margin-bottom:40px;
                padding: 0 38px;
            }
        }

        & .article__cards {
            display: flex;
            gap:50px;
            margin:0 0 30px;

            @mixin screen-lg {
                gap:40px;
            }

            @mixin screen-md {
                gap:24px;
                margin:0;
                flex-direction: column;
            }

            @mixin screen-sm {
                gap:60px;
            }
        }
    }

    .no-wave-bottom {
        padding-top:120px;

        @mixin screen-lg {
            padding-top:80px;
        }

        @mixin screen-md {
            padding-top:60px;
        }
    }

    .no-wave-bottom {
        padding-bottom:120px;

        @mixin screen-lg {
            padding-bottom:80px;
        }

        @mixin screen-md {
            padding-bottom:60px;
        }
    }


</style>
